var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"technology"}},[_c('p',{staticClass:"title"},[_vm._v("我们的技术支持")]),_c('ul',{staticClass:"wow animate__animated animate__lightSpeedInLeft"},_vm._l((_vm.web4),function(item,index){return _c('li',{key:index},[_c('img',{attrs:{"src":item,"alt":""}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }